import { AxiosResponse } from "axios";
import { APICallInstance } from "./APICallInstance";
import { FileKind, UploadFileResponse } from "Application/models";

class UploadFileServiceClass {

    // uploadFile = async (passportNumber: string, attachment: File) => {
    //     const url = '/api/v1/file/upload';

    //     const formData = new FormData();
    //     formData.append('attachment', attachment);
    
    //     try {
    //         const response: AxiosResponse<UploadFileResponse> = await APICallInstance.post(url, formData,
    //             {
    //                 params: {
    //                   passportNumber: passportNumber,
    //                 }
    //         });
    //         console.log(response)
    //         return response.data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }

    uploadFile = async (passportNumber: string, attachment: File, fileKind: FileKind) => {
        const url = '/api/v1/file/upload';

        const formData = new FormData();
        formData.append('attachment', attachment);
    
        try {
            const response: AxiosResponse<UploadFileResponse> = await APICallInstance.post(url, formData,
                {
                    params: {
                      identificationNumber: passportNumber,
                      fileType: fileKind
                    }
            });
            console.log(response)
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const UploadFileService = new UploadFileServiceClass()